import { render } from "./ShareVariantOutline.vue?vue&type=template&id=259007b8"
import script from "./ShareVariantOutline.vue?vue&type=script&lang=js"
export * from "./ShareVariantOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__